/**
 * Parcours guidé « du vol au modèle déployé » (ADR-0020).
 *
 * L'avancement n'est **jamais stocké** : il se **déduit** des données réelles de l'organisation
 * (vidéos, annotations, modèles, évaluations). Le parcours est une *lecture* de l'état, pas un
 * état parallèle qui finirait par diverger — on ne peut donc pas marquer une étape « faite » sans
 * que la donnée correspondante existe. Cette fonction est le contrat unique : la page Parcours et
 * la bande de guidage d'Overview la partagent, pour que « faite » veuille dire la même chose partout.
 */
/** Étapes canoniques, dans l'ordre de progression. */
export const WORKFLOW_STEP_IDS = ['data', 'annotation', 'model', 'evaluation', 'deploy'];
/** Déduit l'avancement du parcours à partir des seuls signaux de données. Pure, sans effet de bord. */
export function deriveWorkflowProgress(signals) {
    const done = {
        data: signals.videoCount > 0,
        annotation: signals.annotatedVideoCount > 0,
        model: signals.readyModelCount > 0,
        evaluation: signals.evaluatedModelCount > 0,
        // Le déploiement n'est pas encore ouvert : jamais « fait », toujours verrouillé (ADR-0014, Phase D).
        deploy: false,
    };
    const locked = {
        data: false,
        annotation: false,
        model: false,
        evaluation: false,
        deploy: true,
    };
    // Point de reprise : la première étape ouverte qui n'est pas encore satisfaite. Chaque étape est
    // évaluée indépendamment — un modèle adopté peut être « fait » alors que l'annotation ne l'est pas,
    // et le parcours pointe alors la lacune la plus en amont.
    const currentStepId = WORKFLOW_STEP_IDS.find((id) => !done[id] && !locked[id]) ?? null;
    const steps = WORKFLOW_STEP_IDS.map((id) => {
        const state = locked[id]
            ? 'locked'
            : done[id]
                ? 'done'
                : id === currentStepId
                    ? 'current'
                    : 'todo';
        return { id, state };
    });
    const actionableCount = WORKFLOW_STEP_IDS.filter((id) => !locked[id]).length;
    const completedCount = WORKFLOW_STEP_IDS.filter((id) => done[id] && !locked[id]).length;
    return { steps, currentStepId, completedCount, actionableCount };
}
//# sourceMappingURL=workflow.js.map